import { styled } from "@mui/material/styles";
import { Stack, TableRow } from "@mui/material";
import { HubHookFormDatePicker } from "../../components";

export const StyledSubStack = styled(Stack)(({ theme }) => ({
  padding: "15px",
  // borderRight: "1px solid",
  // borderLeft: "1px solid",
  // borderColor: theme.palette.hubColors.greyLight,
}));

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => !["main"].includes(prop),
})(({ theme, main }) => ({
  "& .MuiTableCell-root": {
    // height: "52px",
    // padding: "4px 5px !important",
    ...(main
      ? { backgroundColor: theme.palette.hubColors.mainFocusLightest }
      : {}),
    padding: "0px",
    ">.MuiTypography-root": {
      marginLeft: "13px",
    },
    ".MuiInputBase-root, input": {
      borderRadius: 0,
      ...(main ? { backgroundColor: "transparent" } : {}),
    },
    fieldset: {
      borderWidth: "0px",
    },
    "&[disabled]": {
      backgroundColor: theme.palette.hubColors.greyLighter,
      ".MuiInputBase-root": {
        backgroundColor: theme.palette.hubColors.greyLighter,
      },
      ".MuiInputBase-root input": {
        backgroundColor: theme.palette.hubColors.greyLighter,
      },
      ".MuiInputBase-input": {
        backgroundColor: theme.palette.hubColors.greyLighter,
      },
      ".MuiIconButton-root": {
        backgroundColor: theme.palette.hubColors.greyLighter,
        color: theme.palette.hubColors.greyShade,
      },
      ".MuiInputBase-root.Mui-disabled input, .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: theme.palette.hubColors.greyShade,
        color: theme.palette.hubColors.greyShade,
        opacity: 1,
      },
      ".MuiSvgIcon-root": {
        color: theme.palette.hubColors.greyShade,
      },
    },
  },
}));

export const StyledHubHookFormDatePicker = styled(HubHookFormDatePicker, {
  shouldForwardProp: (prop) => true,
})({
  input: {
    width: 130,
  },
  "& .MuiIconButton-root": {
    paddingLeft: 0,
  },
});
